// Angular
import { Component, ViewChild, Input } from '@angular/core';

// Angular Material
import { MatDialog } from '@angular/material/dialog';

// components
import { CloseOpenHouseDialogComponent } from '@app/components/close-open-house-dialog/close-open-house-dialog.component';
import { ReturnToSurveyDialogComponent } from '@app/components/return-to-survey-dialog/return-to-survey-dialog.component';
import { SearchBarComponent } from '@app/components/search-bar/search-bar.component';

@Component({
  selector: 'oh-admin-guest-select',
  templateUrl: './admin-guest-select.component.html',
  styleUrls: ['./admin-guest-select.component.scss'],
})
export class AdminGuestSelectComponent {
  @Input() submissions: any;
  @Input() openHouse: any;
  @Input() allowImport: boolean;
  @ViewChild(SearchBarComponent) searchBar: any;
  public selectedGuest: any;

  constructor(private dialog: MatDialog) {}

  public async selectGuest(submission: any) {
    if (this.selectedGuest == submission) {
      this.selectedGuest = undefined; // unselect this guest
    } else {
      this.selectedGuest = submission;
    }
  }

  public async backToOpenHouse() {
    this.dialog.open(ReturnToSurveyDialogComponent, {
      width: '450px'
    });
  }

  public async endOpenHouse() {
    this.dialog.open(CloseOpenHouseDialogComponent, {
      width: '450px'
    });
  }

  getSubmissions() {
    if(this.submissions !== undefined && this.searchBar !== undefined) {
      return this.submissions.filter(ss =>
       (this.searchBar.value === undefined || this.searchBar.value === '' || ss.guest.name.toLowerCase().indexOf(this.searchBar.value) !== -1 || ss.guest.email.toLowerCase().indexOf(this.searchBar.value) !== -1)
      );
    }
    return false;
  }
}
